module.exports = "../content/ade1717e588935bdec3d38ca19bd1050.ttf";